// DiscussionDetailsSection.tsx
import React, { useEffect } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSharedStyles } from '../style';
import { DiscussionDetails } from '../types';

interface DiscussionDetailsSectionProps {
    details: DiscussionDetails;
    onPostCountChange: (count: number) => void;
}

const useStyles = makeStyles(() => ({
    detailsSection: {
        padding: '20px',
        borderBottom: '1px solid #eaeaea',
        backgroundColor: '#fff',
        marginBottom: '10px',
        textAlign: "start",
        margin: "0rem 0.25rem",
        borderRadius: "12px !important"
    },
    detailsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: '20px',
        '& > div': {
            marginBottom: '10px',
        },
    },
    detailsLabel: {
        color: '#666',
        marginBottom: '5px',
        textAlign: 'left',
    },
    detailsValue: {
        fontWeight: 500,
        textAlign: 'left',
    },
}));

const DiscussionDetailsSection: React.FC<DiscussionDetailsSectionProps> = ({ details, onPostCountChange }) => {
    const classes = useStyles();
    const sharedClasses = useSharedStyles();
    useEffect(() => {
        console.log(`Current post count: ${details.totalReplies}`);
    }, [details.totalReplies]);

    // If you want to also log when the function is called
    const handlePostCountChange = (count: number) => {
        console.log(`Post count changed to: ${count}`);
        onPostCountChange(count);
    };




    return (
        <Paper elevation={0} className={classes.detailsSection}>
            <Typography className={sharedClasses.font16500} gutterBottom align="left">
                Discussion details
            </Typography>
            <Box className={classes.detailsGrid}>
                <Box>
                    <Typography className={`${classes.detailsLabel} ${sharedClasses.font14400}`}>Created by</Typography>
                    <Typography className={`${classes.detailsValue} ${sharedClasses.font14500}`}>{details.createdBy}</Typography>
                </Box>
                <Box>
                    <Typography className={`${classes.detailsLabel} ${sharedClasses.font14400}`}>Created on</Typography>
                    <Typography className={`${classes.detailsValue} ${sharedClasses.font14500}`}>{details.createdOn}</Typography>
                </Box>
                <Box>
                    <Typography className={`${classes.detailsLabel} ${sharedClasses.font14400}`}>Subject</Typography>
                    <Typography className={`${classes.detailsValue} ${sharedClasses.font14500}`}>{details.subject}</Typography>
                </Box>
                <Box>
                    <Typography className={`${classes.detailsLabel} ${sharedClasses.font14400}`}>Total replies</Typography>
                    <Typography className={`${classes.detailsValue} ${sharedClasses.font14500}`}>{details.totalReplies}</Typography>
                </Box>
                <Box>
                    <Typography className={`${classes.detailsLabel} ${sharedClasses.font14400}`}>Last post on</Typography>
                    <Typography className={`${classes.detailsValue} ${sharedClasses.font14500}`}>{details.lastPostOn}</Typography>
                </Box>
            </Box>
        </Paper>
    );
};

export default DiscussionDetailsSection;